/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Matches the remote IP against IPv4 or IPv6 CIDR ranges. Exactly one of `in`
 *
 * @remarks
 * or `notIn` must be set. Entries are rejected if they have host bits set (such
 * as `10.1.2.3/8`), are IPv4-mapped IPv6 addresses, or carry a zone. Single
 * addresses are returned as full-length prefixes, such as `203.0.113.7/32`.
 */
export type RemoteIpMatch = {
  /**
   * Matches when the remote IP is in at least one of these ranges. Entries
   *
   * @remarks
   * are CIDRs such as `203.0.113.0/24` or single addresses such as
   * `203.0.113.7`.
   */
  in?: Array<string> | undefined;
  /**
   * Matches when the remote IP is in none of these ranges. Entries are CIDRs
   *
   * @remarks
   * such as `198.51.100.0/24` or single addresses such as `198.51.100.7`.
   */
  notIn?: Array<string> | undefined;
};

/** @internal */
export const RemoteIpMatch$inboundSchema: z.ZodType<
  RemoteIpMatch,
  z.ZodTypeDef,
  unknown
> = z.object({
  in: z.array(z.string()).optional(),
  notIn: z.array(z.string()).optional(),
});
/** @internal */
export type RemoteIpMatch$Outbound = {
  in?: Array<string> | undefined;
  notIn?: Array<string> | undefined;
};

/** @internal */
export const RemoteIpMatch$outboundSchema: z.ZodType<
  RemoteIpMatch$Outbound,
  z.ZodTypeDef,
  RemoteIpMatch
> = z.object({
  in: z.array(z.string()).optional(),
  notIn: z.array(z.string()).optional(),
});

export function remoteIpMatchToJSON(remoteIpMatch: RemoteIpMatch): string {
  return JSON.stringify(RemoteIpMatch$outboundSchema.parse(remoteIpMatch));
}
export function remoteIpMatchFromJSON(
  jsonString: string,
): SafeParseResult<RemoteIpMatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RemoteIpMatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RemoteIpMatch' from JSON`,
  );
}
